// Conexão com servidor
export const FALHA_CONECTAR_AO_SERVIDOR = 'Não foi possível conectar ao servidor'
export const ERRO_INTERNO = 'Erro interno'
export const ACESSO_NAO_AUTORIZADO = 'Acesso não autorizado'
